<div class="tag-manager">
  <div class="table-operations">
    <div nz-row [nzGutter]="16">
      <div nz-col [nzSpan]="8">
        <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
          <input type="text" nz-input [(ngModel)]="searchName" placeholder="搜索标签名称" (keyup.enter)="loadTags()" />
        </nz-input-group>
        <ng-template #suffixIconButton>
          <button nz-button nzType="primary" nzSearch (click)="loadTags()"><span nz-icon nzType="search"></span></button>
        </ng-template>
      </div>
      <div nz-col [nzSpan]="16" style="text-align: right;">
        <button nz-button nzType="primary" (click)="openAdd()">新增标签</button>
      </div>
    </div>
  </div>

  <nz-table
    #basicTable
    [nzData]="tags"
    [nzLoading]="loading"
    nzTableLayout="fixed"
    [nzFrontPagination]="true"
    [nzPageSize]="10"
  >
    <thead>
      <tr>
        <th>标签名称</th>
<!--        <th>类型</th>-->
        <th nzWidth="100px">排序</th>
        <th nzWidth="150px">操作</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of basicTable.data">
        <td>{{ data.name }}</td>
<!--        <td>{{ data.type }}</td>-->
        <td>{{ data.seq }}</td>
        <td>
          <a (click)="openEdit(data)">编辑</a>
          <nz-divider nzType="vertical"></nz-divider>
          <a class="delete-btn" (click)="deleteTag(data.id)">删除</a>
        </td>
      </tr>
    </tbody>
  </nz-table>

  <nz-modal
    [(nzVisible)]="modalVisible"
    [nzTitle]="modalTitle"
    (nzOnCancel)="handleCancel()"
    (nzOnOk)="handleOk()"
  >
    <ng-container *nzModalContent>
      <form nz-form>
        <nz-form-item>
          <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired>标签名称</nz-form-label>
          <nz-form-control [nzSm]="14" [nzXs]="24">
            <input nz-input [(ngModel)]="form.name" name="name" placeholder="请输入标签名称" />
          </nz-form-control>
        </nz-form-item>
<!--        <nz-form-item>-->
<!--          <nz-form-label [nzSm]="6" [nzXs]="24">类型</nz-form-label>-->
<!--          <nz-form-control [nzSm]="14" [nzXs]="24">-->
<!--            <input nz-input [(ngModel)]="form.type" name="type" placeholder="标签类型" />-->
<!--          </nz-form-control>-->
<!--        </nz-form-item>-->
        <nz-form-item>
          <nz-form-label [nzSm]="6" [nzXs]="24">排序</nz-form-label>
          <nz-form-control [nzSm]="14" [nzXs]="24">
            <nz-input-number [(ngModel)]="form.seq" name="seq" [nzMin]="0"></nz-input-number>
          </nz-form-control>
        </nz-form-item>
      </form>
    </ng-container>
  </nz-modal>
</div>

